import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { NotificationState } from './types';

export const getters: GetterTree<NotificationState, RootState> = {
  notificationValue(state) {
    const { message, mode, dialogMessage } = state;

    return {
      message,
      mode,
      dialogMessage,
    };
  },
};
